import { render, staticRenderFns } from "./beacon-list.vue?vue&type=template&id=04da2d96&"
import script from "./beacon-list.vue?vue&type=script&lang=js&"
export * from "./beacon-list.vue?vue&type=script&lang=js&"
import style0 from "./beacon-list.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports